import ReportPhotoModal from './ReportPhotoModal';

export default ReportPhotoModal;
